import React, {useCallback, useState} from 'react';

import {Analytics} from '../../../services/analytics';
import {DrawerContentType} from '../WorkspaceDrawerContextProvider';
import {BackButton} from './components/BackButton';
import {LinePlotSectionSettings} from './LinePlotSectionSettings';
import {SectionMediaSettingsDrawer} from './media/SectionMediaSettingsDrawer';
import {
  SectionSettingsMenu,
  SelectedSectionSettingType,
} from './SectionSettingsMenu';

export const SectionSettingsContent = ({
  displayedContentType,
}: {
  displayedContentType: DrawerContentType;
}) => {
  const [selectedSettingType, setSelectedSettingType] = useState<
    SelectedSectionSettingType | undefined
  >();
  const setSelectedSettingTypeAndLog = useCallback(
    (settingType: SelectedSectionSettingType | undefined) => {
      setSelectedSettingType(settingType);
      Analytics.track('Select Section Setting Menu Item', {
        settingType,
      });
    },
    [setSelectedSettingType]
  );
  if (selectedSettingType === undefined) {
    return (
      <SectionSettingsMenu
        setSelectedSettingType={setSelectedSettingTypeAndLog}
      />
    );
  }
  const backButton = (
    <BackButton onClick={() => setSelectedSettingTypeAndLog(undefined)} />
  );
  if (selectedSettingType === SelectedSectionSettingType.LinePlot) {
    return (
      <LinePlotSectionSettings
        contentHeader={backButton}
        displayedContentType={displayedContentType}
      />
    );
  }
  return <SectionMediaSettingsDrawer header={backButton} />;
};
